import { useEffect, useRef, useState } from "react";
import "./NewPreviewUI.css";

import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { enqueueSnackbar } from "notistack";
import { ClipLoader, PropagateLoader } from "react-spinners";

const EditSearchModal = ({ seteditSearch, error }) => {
  const modalContainerRef = useRef(null);
  const [keyword, setkeyword] = useState(null);
  const [fileBlob, setFileBlob] = useState(null);
  const [fileUpload, setfileUpload] = useState(null);
  const time = useSelector((state) => state.time);
  const [meetingname, setmeetingname] = useState(null);
  const [attempts, setAttempts] = useState(0);
  const [showLoader, setshowLoader] = useState(false);
  const [selectedOption, setSelectedOption] = useState("left");
  const [fileName, setFileName] = useState(null);
  const [allowClose, setallowClose] = useState(false);
  const dispatch = useDispatch();
  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (file) {
      try {
        setFileBlob(file);
        setFileName(file.name);
      } catch (error) {
        console.error("Error reading file as Blob:", error);
      }
    }
  };

  const handleToggle = () => {
    setSelectedOption(selectedOption === "left" ? "right" : "left");
    setTimeout(() => {
      setfileUpload(selectedOption === "left");
    }, 200);
  };
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        modalContainerRef.current &&
        !modalContainerRef.current.contains(event.target)
      ) {
        if (error) {
          enqueueSnackbar(
            "Error! Please input some related keywords to get new customisations",
            {
              preventDuplicates: true,
              autoHideDuration: 3000,
              variant: "error",
            }
          );
        } else {
          if (allowClose) {
            seteditSearch(false);
          }
        }
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (time) {
      setmeetingname(time.meetingname);
    }
  }, [time]);

  const handleSaveButtonClick = () => {
    const api = localStorage.getItem("api");
    const headers = JSON.parse(localStorage.getItem("headers"));

    if (fileUpload) {
      uploadFile(api, headers, meetingname);
    } else if (keyword) {
      uploadFile(api, headers, keyword);
    } else {
      enqueueSnackbar("Please Add Either File or Additional Keyword.", {
        variant: "error",
        preventDuplicate: true,
        autoHideDuration: 2000,
      });
    }
  };

  const uploadFile = (api, headers, eventName) => {
    let formData = new FormData();

    if (fileUpload && fileBlob) {
      formData.append("file", fileBlob, fileBlob.name);
    }
    setshowLoader(true);
    axios
      .post(`${api}/dmz?eventName=${eventName}`, formData, {
        headers,
      })
      .then((response) => {
        const json = JSON.parse(localStorage.getItem("MeetingObject"));
        json.customProperties.customisationId = response.data.customisationId;
        localStorage.setItem("MeetingObject", JSON.stringify(json));

        enqueueSnackbar("Success! The Image will be uploaded shortly.", {
          variant: "success",
          preventDuplicate: true,
          autoHideDuration: 2000,
        });

        fetchDataWithRetries(api, headers, response.data.customisationId);
      })
      .catch((e) => {
        console.log(e);
        enqueueSnackbar("Failed to upload the image.", {
          variant: "error",
          preventDuplicate: true,
          autoHideDuration: 2000,
        });
        setshowLoader(false);
      });
  };

  const fetchData = async (api, headers, customisationId) => {
    try {
      const fetchresponse = await axios.get(
        `${api}/dmz?customisationId=${customisationId}`,
        { headers }
      );
      return fetchresponse.data;
    } catch (error) {
      console.error("Error:", error);
      return null;
    }
  };

  const fetchDataWithRetries = async (api, headers, customisationId) => {
    const maxAttempts = 8;
    let attempts = 0;

    const attemptFetch = async () => {
      if (attempts >= maxAttempts) {
        setshowLoader(false);
        enqueueSnackbar(
          "Error! We couldn't get relevant Images. Please input some related keywords to get new customisations",
          { preventDuplicates: true, autoHideDuration: 3000, variant: "error" }
        );
        setallowClose(true);
        return;
      }

      setAttempts((prevAttempts) => prevAttempts + 1);

      try {
        const fetchresponse = await fetchData(api, headers, customisationId);
        if (fetchresponse && fetchresponse.customisations.length > 0) {
          //   dispatch(setPreviewCustomisations(fetchresponse.customisations));
          seteditSearch(false);
          setallowClose(true);
          return;
        }
      } catch (error) {
        console.error("Error:", error);
      }

      attempts += 1;
      setTimeout(attemptFetch, 4000);
    };

    attemptFetch();
  };

  useEffect(() => {
    if (error) {
      enqueueSnackbar(
        "Error Fetching customisations based on your input. Please try again",
        { preventDuplicate: true, variant: "error", autoHideDuration: 3000 }
      );
    }
  }, [error]);
  return (
    <div className="modelwrapper" style={{ zIndex: 1000 }}>
      <div
        className="modelcontainer"
        ref={modalContainerRef}
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        <div className="editSearchContainer">
          <div className="toggle-container">
            <div
              className={`toggle-option ${
                selectedOption === "left" ? "selected" : ""
              }`}
              onClick={handleToggle}
            >
              Add Keywords
            </div>
            <div
              className={`toggle-option ${
                selectedOption === "right" ? "selected" : ""
              }`}
              onClick={handleToggle}
            >
              Upload File
            </div>
          </div>
          {fileUpload ? (
            <>
              <div className="editModalInputContainer">
                <div
                  className="rightmodalsingleinputcontainer"
                  style={{ width: "80%" }}
                >
                  <div className="custom-file-input">
                    <input
                      type="file"
                      className="rightmodalsinglinputfield"
                      placeholder="Upload Image"
                      style={{ width: "20vw" }}
                      onChange={handleFileChange}
                      accept=".jpeg, .jpg, .png, .mp4, .avi, .mov"
                      id="fileInput"
                    />
                    <label for="fileInput" style={{ height: "5vh" }}>
                      {fileName ? fileName : "Upload Image"}
                    </label>
                  </div>
                </div>
              </div>
            </>
          ) : (
            <>
              <div className="editModalInputContainer">
                <div
                  className="rightmodalsingleinputcontainer"
                  style={{ width: "80%" }}
                >
                  <input
                    type="text"
                    className="rightmodalsinglinputfield"
                    style={{ width: "100%" }}
                    placeholder="Additional Keywords"
                    onChange={(e) => {
                      setkeyword(e.target.value);
                    }}
                  />
                </div>
              </div>
            </>
          )}
          <div className="editModalInputSaveButtonContainer">
            {showLoader ? (
              <div className="editModalInputSaveButton">
                <ClipLoader color="white" />
              </div>
            ) : (
              <span
                className="editModalInputSaveButton"
                onClick={handleSaveButtonClick}
              >
                Save
              </span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditSearchModal;
